/* eslint-disable no-new */
export default {
    /**
     * @override
     */
    setConfigVars({ commit }, configVars) {
        return new Promise(resolve => {
            commit('SET_CONFIGVARS', configVars);
            resolve();
        });
    },
    setFlowFlags({ commit }, flowFlags) {
        return new Promise(resolve => {
            commit('SET_FLOW_FLAGS', flowFlags);
            resolve();
        });
    },
    resetFlowFlags: ({ commit }) => {
      commit("RESET_FLOW_FLAGS");
    },
};
